import React from 'react';
import styles from './Footer.module.css';

interface SocialLink {
  label: string;
  href: string;
}

interface FooterProps {
  logoSrc: string;
  logoAlt?: string;
  watermarkLogoSrc?: string;
  watermarkLogoAlt?: string;
  phone: string;
  email: string;
  socialLinks: SocialLink[];
  copyrightText: string;
}

const Footer: React.FC<FooterProps> = ({
  logoSrc,
  logoAlt = 'Brand Logo',
  watermarkLogoSrc,
  watermarkLogoAlt = 'Watermark Logo',
  phone,
  email,
  socialLinks,
  copyrightText,
}) => {
  return (
    <footer className={styles.customFooter}>
      <div className={styles.footerContainer}>
        {/* Left */}
        <div className={styles.footerLeft}>
          <img src={logoSrc} alt={logoAlt} />
          <div className={styles.footerContact}>
            📞 Contact Us: {phone} <br />
            ✉️ Email: {email}
          </div>
          <div className={styles.footerSocial}>
            {socialLinks.map((link, idx) => (
              <React.Fragment key={link.href}>
                <a href={link.href} target="_blank" rel="noopener noreferrer">
                  {link.label}
                </a>
                {idx < socialLinks.length - 1 && ' | '}
              </React.Fragment>
            ))}
          </div>
        </div>

        {/* Right watermark logo */}
        {watermarkLogoSrc && (
          <div className={styles.footerRight}>
            <img src={watermarkLogoSrc} alt={watermarkLogoAlt} />
          </div>
        )}
      </div>

      {/* Bottom bar */}
      <div className={styles.footerBottom}>{copyrightText}</div>
    </footer>
  );
};

export default Footer;
